import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import CheckboxGroup from "../../common/CheckboxGroup";
import SwitchWithLabel from "../../common/CustomSwitch";
import Select from "../../../../../../common/StyledSelect";
import { ONLY_NUMBER_REGEX, ALPHA_NUMERIC_REGEX } from "../../../constRegex";
import ProDetails from "./ProDetails";
import HazmatDetails from "./HazmatDetails";
import PackageDetails from "./PackageDetails";
import ShipmentDetails from "./ShipmentDetails";
import { COUNTRIES, LIMITED_ACCESS_PICKUP } from "../../../constants";
import { isEqual } from "lodash/lang";
class EditPickupProForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cityNameList: this.setCityList(),
      consigneeNameList: this.getConsigneeList(),
    };
  }
  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.cityList, this.props.cityList) ||
      prevProps.editInfo.consigneeCountry !=
        this.props.editInfo.consigneeCountry ||
      prevProps.editInfo.consigneeZip != this.props.editInfo.consigneeZip
    ) {
      this.updateCityListOnChange();
    }
    if (
      prevProps.editInfo.consigneeName !== this.props.editInfo.consigneeName
    ) {
      this.handleChange("consigneeName")({
        label: this.props.editInfo.consigneeName,
        value: null,
      });
    }
  }

  updateCityListOnChange = () => {
    const consigneeCity = this.props.editInfo.consigneeCity;
    const cityNameList = this.getCityList();
    const selectedConsigneeCity = cityNameList.find(
      (cityData) => cityData.label == consigneeCity
    );
    this.setState({
      cityNameList,
    });
    if (consigneeCity || selectedConsigneeCity) {
      this.handleChange("consigneeCity")({
        label: consigneeCity,
        value: consigneeCity,
      });
    }
  };

  validateZipCodeValue = (countryValue) => {
    const format =
      countryValue === COUNTRIES.CN ? ALPHA_NUMERIC_REGEX : ONLY_NUMBER_REGEX;
    const inputValue = this.props.editInfo.consigneeZip;
    return format.test(inputValue);
  };

  getCityList = () => {
    return this.props.cityList.map((cityData) => {
      return {
        label: cityData.city,
        value: cityData.city,
      };
    });
  };
  setCityList = () => {
    const value = this.props.editInfo.consigneeCity;
    const cityNameList = this.getCityList();
    const selectedValue = cityNameList.find(
      (cityData) => cityData.label == value
    );
    if (!selectedValue && value) {
      return [
        ...cityNameList,
        {
          label: value,
          value: value,
        },
      ];
    }
    return cityNameList;
  };

  getConsigneeList = () => {
    const value = this.props.editInfo.consigneeName;
    const selectedValue = this.props.consigneeList.find(
      (consignee) => consignee.label == value
    );
    if (!selectedValue && value) {
      return [
        ...this.props.consigneeList,
        {
          label: value,
          value: null,
        },
      ];
    }
    return this.props.consigneeList;
  };

  handleChange = (name, index) => (value) => {
    const { handleChange } = this.props;
    if (
      [
        "packageCode",
        "consigneeCountry",
        "limitedAccessCode",
        "consigneeCity",
        "rmaxShipperCode",
      ].includes(name)
    ) {
      value = value && value.value;
    }
    switch (name) {
      case "consigneeCountry": {
        if (
          Boolean(this.props.editInfo.consigneeZip) &&
          !this.validateZipCodeValue(value)
        ) {
          this.handleChange("consigneeZip")("");
        }
        break;
      }
      case "consigneeName": {
        value = value && value.label;
        const data = this.props.consigneeList.find(
          (consignee) => consignee.label == value
        );
        if (data) {
          handleChange("consigneeCode", index)(data.value);
        } else {
          handleChange("consigneeCode", index)(null);
          this.updateConsigneeName(value);
        }
        break;
      }
      case "consigneeCity": {
        const data = this.props.cityList.find(
          (cityData) => cityData.city == value
        );
        if (data) {
          handleChange("consigneeState", index)(data.state);
        } else {
          this.updateCityName(value);
          handleChange("consigneeState", index)(null);
        }
        break;
      }
    }
    handleChange(name, index)(value);
  };

  updateCityName = (value) => {
    const selectedValue = this.state.cityNameList.find(
      (cityData) => cityData.label == value
    );
    if (!selectedValue && value) {
      this.setState((state) => ({
        cityNameList: [...state.cityNameList, { label: value, value: value }],
      }));
    }
  };
  updateConsigneeName = (value) => {
    const selectedValue = this.state.consigneeNameList.find(
      (consignee) => consignee.label == value
    );
    if (!selectedValue && value) {
      this.setState((state) => ({
        consigneeNameList: [
          ...state.consigneeNameList,
          { label: value, value: null },
        ],
      }));
    }
  };

  render() {
    const {
      classes,
      accessorialList,
      priorityShipmentsList,
      editInfo,
      errorInfo,
      limitedAccessList,
      excessiveShipmentList,
      openHazmatEntryForm,
      showHazmatCards,
      hazmatInfo,
      saveHazmatEntry,
      handleHazmatEdit,
      handleHazmatCardDelete,
      isAddHazmatClicked,
      closeHazmatForm,
      packageTypeList,
      countryList,
      forwardRef,
      handleBlur,
      addItem,
      addHazmatEntry,
      hazmatArray,
      stopData,
      proNumberLength
    } = this.props;
    const isLimitedAccessChecked =
      editInfo.accessorials.length > 0
        ? editInfo.accessorials.find(
            (ele) => ele.name === LIMITED_ACCESS_PICKUP
          )?.isChecked
        : false;
    return (
      <React.Fragment>
        <div ref={forwardRef}>
          <ProDetails
            editInfo={editInfo}
            errorInfo={errorInfo}
            countryList={countryList}
            cityList={this.state.cityNameList}
            handleBlur={handleBlur}
            consigneeList={this.state.consigneeNameList}
            handleChange={this.handleChange}
            stopData={stopData}
            proNumberLength={proNumberLength}
          />
          {editInfo.consigneeCountry === COUNTRIES.CN && (
            <SwitchWithLabel
              rowLabel="Received Canadian Documentation"
              onChange={this.handleChange("receivedCanadianDocumentation")}
              value={editInfo.receivedCanadianDocumentation}
            />
          )}
          <PackageDetails
            editInfo={editInfo}
            errorInfo={errorInfo}
            packageTypeList={packageTypeList}
            handleChange={this.handleChange}
            addItem={addItem}
          />

          <CheckboxGroup
            options={
              editInfo.accessorials.length > 0
                ? editInfo.accessorials
                : accessorialList
            }
            onChange={this.handleChange("accessorials")}
            headerLabel="ACCESSORIALS"
          />
          {isLimitedAccessChecked && (
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "limitedAccessCode",
                  label: "Limited Access",
                  variant: "outlined",
                  helperText: errorInfo.limitedAccessCode,
                }}
                error={Boolean(errorInfo.limitedAccessCode)}
                value={editInfo.limitedAccessCode}
                onChange={this.handleChange("limitedAccessCode")}
                data={limitedAccessList}
              />
            </div>
          )}
          <ShipmentDetails
            priorityShipmentsList={priorityShipmentsList}
            editInfo={editInfo}
            errorInfo={errorInfo}
            excessiveShipmentList={excessiveShipmentList}
            handleChange={this.handleChange}
          />
          <HazmatDetails
            openHazmatEntryForm={openHazmatEntryForm}
            showHazmatCards={showHazmatCards}
            hazmatInfo={hazmatInfo}
            saveHazmatEntry={saveHazmatEntry}
            handleHazmatEdit={handleHazmatEdit}
            handleHazmatCardDelete={handleHazmatCardDelete}
            isAddHazmatClicked={isAddHazmatClicked}
            closeHazmatForm={closeHazmatForm}
            handleChange={this.handleChange}
            hazmatArray={hazmatArray}
            addHazmatEntry={addHazmatEntry}
            editInfo={editInfo}
            errorInfo={errorInfo}
            packageTypeList={packageTypeList}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(EditPickupProForm);
